(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    (() => {
    const productCards = document.querySelectorAll('[data-product-card]');

    productCards.forEach((card) => {
      const variantSelect = card.querySelector('[data-variant-select]');

      if (!variantSelect) return;

      const price = card.querySelector('[data-variant-price]');
      const addToCartButton = card.querySelector('[data-add-to-cart]');
      const productImage = card.querySelector('.product-card__media img');
      const productMediaLink = card.querySelector('a.product-card__media');

      const updateVariantState = () => {
        const selectedOption = variantSelect.options[variantSelect.selectedIndex];

        if (!selectedOption) return;

        if (productImage && selectedOption.dataset.mediaSrc) {
          productImage.src = selectedOption.dataset.mediaSrc;

          if (selectedOption.dataset.mediaSrcset) {
            productImage.srcset = selectedOption.dataset.mediaSrcset;
          }

          productImage.alt = selectedOption.dataset.mediaAlt || '';
        }

        if (productMediaLink && selectedOption.dataset.url) {
          productMediaLink.href = selectedOption.dataset.url;
        }

        if (price && selectedOption.dataset.price) {
          const pricePrefix = price.dataset.pricePrefix;

          if (pricePrefix) {
            price.textContent = `${pricePrefix} ${selectedOption.dataset.price}`;
          } else {
            price.textContent = selectedOption.dataset.price;
          }
        }

        if (addToCartButton) {
          const isAvailable = selectedOption.dataset.available === 'true';
          const buttonLabel = addToCartButton.querySelector('.btn__label') || addToCartButton;

          addToCartButton.disabled = !isAvailable;

          if (isAvailable) {
            buttonLabel.textContent = addToCartButton.dataset.availableLabel;
          } else {
            buttonLabel.textContent = addToCartButton.dataset.soldOutLabel;
          }
        }

        window.dispatchEvent(
          new CustomEvent('earthly:products-updated', {
            detail: { root: card },
          })
        );
      };

      variantSelect.addEventListener('change', updateVariantState);
      updateVariantState();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
